import * as Context from "effect/Context";
import type * as Stream from "effect/Stream";
import type { EnvironmentId } from "@afar-research/contracts";

import type { HostEnvironmentRegistration } from "../connection/host.ts";

export type PlatformConnectionChange =
  | { readonly _tag: "InstallHost"; readonly registration: HostEnvironmentRegistration }
  | { readonly _tag: "ReplaceHost"; readonly registration: HostEnvironmentRegistration }
  | { readonly _tag: "RemoveHost"; readonly environmentId: EnvironmentId };

export class PlatformConnectionSource extends Context.Service<
  PlatformConnectionSource,
  {
    readonly changes: Stream.Stream<PlatformConnectionChange>;
  }
>()("@afar-research/client-runtime/platform/source/PlatformConnectionSource") {}
